// extracted by mini-css-extract-plugin
module.exports =  {"text":"a10a3f92e9--text--rMX1d","data":"a10a3f92e9--data--bZPuq","percent":"a10a3f92e9--percent--BK2Zq","percent-bar":"a10a3f92e9--percent-bar--NQfZK"};